import type { PasteOptionsToolbarPluginConfiguration } from '@atlaskit/editor-plugin-paste-options-toolbar/paste-options-toolbar-plugin-type';
import { markdownToAdf } from '@atlassian/editor-plugin-markdown-mode/markdown-conversion';

interface Props {
	options: PasteOptionsToolbarPluginConfiguration | undefined;
	usePopupBasedPasteActionsMenuDefault: boolean | undefined;
}

/**
 * Builds paste-options-toolbar plugin options for Confluence full-page preset.
 * Injects markdown-plus converter while preserving any caller-provided override.
 */
export function pasteOptionsToolbarPluginOptions({
	options,
	usePopupBasedPasteActionsMenuDefault,
}: Props): PasteOptionsToolbarPluginConfiguration {
	const markdownToPmConverter =
		options?.markdownToPmConverter ??
		(({ markdown, schema }) => markdownToAdf(markdown, schema).content);

	return {
		markdownToPmConverter,
		pasteMenuButtonsFactory: options?.pasteMenuButtonsFactory,
		usePopupBasedPasteActionsMenu:
			options?.usePopupBasedPasteActionsMenu ?? usePopupBasedPasteActionsMenuDefault,
	};
}
